import ServerDirections from '@/config/server-directions'
import { UserData } from '@/entities/UserData'
import store from '@/store'

export class Requests {
  getUserData (id) {
    return new Promise((resolve, reject) => {
      window.vm.$http
        .get(ServerDirections.USER_DATA.replace('{instanceId}', store.state.configuration.instanceId).replace('{id}', id))
        .then(
          data => {
            resolve(new UserData(data.body))
          },
          error => {
            reject(error)
          }
        )
    })
  }

  requestRefund (userId, bankData, bankAccountType) {
    const body = {
      first_name: bankData.name,
      last_name: bankData.surname,
      second_last_name: bankData.secondSurname,
      email: bankData.email,
      phone: bankData.phone.replace(/ /g, '').replace('+', ''),
      document_type: bankData.documentType,
      document: bankData.document,
      bank_account: {
        type: bankAccountType,
        number: bankData.bankAccountNumber
      }
    }
    return new Promise((resolve, reject) => {
      window.vm.$http
        .post(ServerDirections.REFUND.replace('{instanceId}', store.state.configuration.instanceId).replace('{id}', userId), body, {
          headers: {
            'x-user-locale':
              ((navigator.language || navigator.userLanguage).split('-')[0] === 'es')
                ? 'ES'
                : ((navigator.language || navigator.userLanguage).split('-')[0] === 'it')
                  ? 'IT'
                  : ((navigator.language || navigator.userLanguage).split('-')[0] === 'pt')
                    ? 'PT'
                    : ((navigator.language || navigator.userLanguage).split('-')[0] === 'ca')
                      ? 'CA'
                      : 'EN'
          }
        })
        .then(
          () => {
            resolve()
          },
          error => {
            reject(error)
          }
        )
    })
  }

  getConfiguration () {
    return new Promise((resolve, reject) => {
      window.vm.$http
        .get(ServerDirections.CONFIGURATION.replace('{id}', store.state.configuration.instanceId))
        .then(
          data => {
            resolve(data.body)
          },
          error => {
            reject(error)
          }
        )
    })
  }
}
